<template>
  <div class="classes-detail-teachers">
    <BlockTabs
      :items="tabs"
      currentClass="bold5"
      isNew
      @changeTab="changeTab"
    ></BlockTabs>
    <div
      class="classes-detail-teachers-container"
      v-if="currentTeachers.length > 0"
    >
      <div
        class="classes-detail-teacher"
        :class="{ 'classes-detail-teacher_hover': currentTab == 1 }"
        v-for="tea in currentTeachers"
        :key="tea.id"
        @click="onTeacherClick(tea)"
      >
        <img class="classes-detail-teacher_avatar" :src="tea.avatar" />
        <div>
          <div class="classes-detail-teacher_name bold6">
            {{ tea.real_name }}
          </div>
          <div class="classes-detail-teacher_market">
            {{ tea.marketing_language }}
          </div>
        </div>
      </div>
    </div>
    <div class="classes-detail-teachers-arrow_wrap" v-if="teachers.length > 3">
      <div
        class="classes-detail-teachers-arrow classes-detail-teachers-arrow_left"
        :class="{ 'classes-detail-teachers-arrow_disabled': start == 0 }"
        @click="onNavigate(-1)"
      ></div>
      <div
        class="classes-detail-teachers-arrow classes-detail-teachers-arrow_right"
        :class="{
          'classes-detail-teachers-arrow_disabled':
            start == teachers.length - 3,
        }"
        @click="onNavigate(1)"
      ></div>
    </div>
    <EmptyNew
      v-if="currentTeachers.length == 0"
      title="暂无教学团队"
    ></EmptyNew>
  </div>
</template>
<script>
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "ClassesDetailTeachers",
  components: { EmptyNew },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentTab: 1,
      tabs: [
        { id: 1, name: "教学团队" },
        // { id: 2, name: "班主任" },
      ],
      start: 0,
    };
  },
  computed: {
    teachers() {
      return this.currentTab == 1
        ? this.detail.teachers || []
        : [this.detail.head_teacher];
    },
    currentTeachers() {
      return this.teachers.slice(this.start, this.start + 3);
    },
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab.id;
    },
    onNavigate(step) {
      let start = this.start + step;
      if (start < 0) {
        start = 0;
      } else if (start > this.teachers.length - 3) {
        start = this.teachers.length - 3;
      }
      this.start = start;
    },
    onTeacherClick(tea) {
      if (this.currentTab != 1) {
        return;
      }
      this.$router.push({
        name: "ShowTeachersDetaial",
        params: { id: tea.id },
        query: { route_label: "讲师", route_name: "ShowTeachers" },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-detail-teachers {
  background: #ffffff;
  border-radius: 4px;
  padding: 8px 24px 24px 20px;
  position: relative;
  margin-bottom: 24px;

  /deep/ {
    .tab-item {
      width: auto !important;
      margin-right: 32px !important;
    }
  }
}
.classes-detail-teachers-container {
  display: flex;
  margin-top: 12px;
}
.classes-detail-teacher {
  width: calc(100% / 3);
  display: flex;
}
.classes-detail-teacher_hover {
  cursor: pointer;
}
.classes-detail-teacher_avatar {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  margin-right: 12px;
}
.classes-detail-teacher_name {
  font-family: PingFangSC, PingFangSC-Semibold;
  line-height: 22px;
  margin-bottom: 2px;
}
.classes-detail-teacher_market {
  color: #999999;
  line-height: 22px;
}
.classes-detail-teachers-arrow_wrap {
  position: absolute;
  top: 27px;
  right: 24px;
  display: flex;
}
.classes-detail-teachers-arrow {
  width: 18px;
  height: 18px;
  background-size: 100% 100%;
  cursor: pointer;
}
.classes-detail-teachers-arrow_left {
  background-image: url("~@/assets/images/classes/arrow-left@2x.png");
  margin-right: 17px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 1px;
    right: -9px;
    width: 1px;
    height: 16px;
    background: #d8d8d8;
  }
}
.classes-detail-teachers-arrow_right {
  background-image: url("~@/assets/images/classes/arrow-right@2x.png");
}
.classes-detail-teachers-arrow_disabled {
  cursor: not-allowed;
}
</style>
